module.exports = __webpack_public_path__ + "static/media/pro-4.b3a755ee.jpg";